import styled from "@emotion/styled";
import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { NoDataGraph } from "../../../assets";
import { GamePreview } from "../../../components/GamePreview";
import BasicSelect from "../../../components/Select";
import { PieChart } from "./PieChart";

const FlexRow = styled(Box)({
  display: "flex",
  flexDirection: "row",
});
const FlexColumn = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const ScholarStatistics = ({ colors, nfts, games }) => {
  return (
    <FlexColumn
      width="90%"
      height={400}
      style={{
        alignItems: "flex-start",
        justifyContent: "space-between",
        marginBottom: "200px",
      }}
    >
      <Typography
        variant="subtitle2"
        color={colors.black[500]}
        fontWeight={500}
      >
        Scholar Statistics
      </Typography>
      <FlexRow width="100%" style={{ justifyContent: "space-between" }}>
        <FlexColumn
          width={"49%"}
          // height={"500px"}
          sx={{
            borderRadius: "16px",
            backgroundColor: "#ffffff",
            justifyContent: "space-evenly",
          }}
        >
          {true ? (
            <PieChart />
          ) : (
            <>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src={NoDataGraph} alt="graph" />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: "12px",
                  width: "100%",
                  //   height: "130px",
                }}
              >
                <Stack direction="row">
                  <Typography
                    variant="fs14"
                    color={colors.black[900]}
                    fontWeight={500}
                    marginRight="6px"
                  >
                    0%
                  </Typography>
                  <Typography
                    variant="fs14"
                    color={colors.black[900]}
                    fontWeight={500}
                  >
                    Scholar Share
                  </Typography>
                </Stack>

                <Stack direction="row" ml={"30px"}>
                  <Typography
                    variant="fs14"
                    color={colors.black[900]}
                    fontWeight={500}
                    marginRight="6px"
                  >
                    0%
                  </Typography>
                  <Typography
                    variant="fs14"
                    color={colors.black[900]}
                    fontWeight={500}
                  >
                    Guild Share
                  </Typography>
                </Stack>
              </Box>
            </>
          )}
        </FlexColumn>

        <FlexColumn
          width={"49%"}
          // height={"500px"}
          sx={{
            borderRadius: "16px",
            backgroundColor: "#ffffff",
            justifyContent: "space-evenly",
            // alignItems: "center",
            paddingLeft: "10px",
          }}
        >
          <BasicSelect properties={[]} width={"97%"} />

          <FlexRow
            sx={{
              alignItems: "center",
              justifyContent: "space-between",
              width: "97%",
              paddingLeft: "40px",
              paddingRight: "40px",
              borderBottom: "1px solid #E8ECF5",
              height: "80px",
            }}
          >
            <Typography
              variant="caption"
              color={colors.black[500]}
              fontWeight={500}
            >
              Number of NFTs
            </Typography>
            <FlexRow
              sx={{
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                variant="h5"
                color={colors.black[500]}
                fontWeight={500}
                mr="15px"
              >
                N/A
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  position: "relative",
                  width: "124px",
                  height: "55px",
                }}
              >
                {nfts.map((nft, index) => (
                  <img
                    src={nft.image}
                    alt="nft"
                    style={{
                      width: "44px",
                      height: "55px",
                      borderRadius: "7px",
                      position: "absolute",
                      left: `${20 * index}px`,
                      zIndex: nfts.length - index,
                    }}
                  />
                ))}
              </Box>
            </FlexRow>
          </FlexRow>

          <FlexRow
            sx={{
              alignItems: "center",
              justifyContent: "space-between",
              width: "97%",
              paddingLeft: "40px",
              paddingRight: "40px",
              borderBottom: "1px solid #E8ECF5",
              height: "80px",
            }}
          >
            <Typography
              variant="caption"
              color={colors.black[500]}
              fontWeight={500}
            >
              Time Played
            </Typography>
            <FlexRow
              sx={{
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                variant="h5"
                color={colors.black[500]}
                fontWeight={500}
                mr="15px"
              >
                N/A
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  position: "relative",
                  width: "124px",
                  height: "55px",
                }}
              >
                {nfts.map((nft, index) => (
                  <img
                    src={nft.image}
                    alt="nft"
                    style={{
                      width: "44px",
                      height: "55px",
                      borderRadius: "7px",
                      position: "absolute",
                      left: `${20 * index}px`,
                      zIndex: nfts.length - index,
                    }}
                  />
                ))}
              </Box>
            </FlexRow>
          </FlexRow>

          <FlexColumn
            sx={{
              alignItems: "flex-start",
              justifyContent: "space-between",
              width: "97%",
              paddingLeft: "40px",
              paddingRight: "40px",

              borderBottom: "1px solid #E8ECF5",
              // height: "80px",
            }}
          >
            <Typography
              variant="caption"
              color={colors.black[500]}
              fontWeight={500}
            >
              Games
            </Typography>
            <FlexRow
              sx={{
                alignItems: "center",
                justifyContent: "space-evenly",
                width: "100%",
                marginBottom: "30px",
              }}
            >
              {games.map((nft, index) => (
                <GamePreview
                  key={index}
                  collectionName={nft.collectionName}
                  image={nft.image}
                />
              ))}
            </FlexRow>
          </FlexColumn>

          <BasicSelect properties={[]} width={"97%"} />
        </FlexColumn>
      </FlexRow>
    </FlexColumn>
  );
};
